import React from 'react';
import { Container, Row, Col, Button, Card, CardImg } from 'reactstrap';
import { withNamespaces } from 'react-i18next';

const items = [
  // pt
  {
    image: 'game_pt_01',
    // name: '紫色狂热',
  },
  {
    image: 'game_pt_02',
    // name: '亞洲幻想',
  },
  {
    image: 'game_pt_03',
    // name: '碧波',
  },
  {
    image: 'game_pt_04',
    // name: '翡翠公主',
  },
  {
    image: 'game_pt_05',
    // name: '酷炫水果農場',
  },
  {
    image: 'game_pt_06',
    // name: '水果狂',
  },
  {
    image: 'game_pt_07',
    // name: '寶石女王',
  },
  {
    image: 'game_pt_08',
    // name: '幸運愛爾蘭',
  },
  {
    image: 'game_pt_09',
    // name: '武則天',
  },
  {
    image: 'game_pt_10',
    // name: '三個火槍手',
  },
  // mg
  {
    image: 'game_mg_01',
    // name: '泰山',
  },
  {
    image: 'game_mg_02',
    // name: '幸運寶貝龍',
  },
  {
    image: 'game_mg_03',
    // name: '夢果子樂園',
  },
  {
    image: 'game_mg_04',
    // name: '金庫甜心',
  },
  {
    image: 'game_mg_05',
    // name: '好日子',
  },
  {
    image: 'game_mg_06',
    // name: '搶劫銀行',
  },
  {
    image: 'game_mg_07',
    // name: '足球明星',
  },
  {
    image: 'game_mg_08',
    // name: '寶石迷陣',
  },
  {
    image: 'game_mg_09',
    // name: '海濱財富',
  },
  {
    image: 'game_mg_10',
    // name: '太陽神之忒伊亞',
  },
  // jdb
  {
    image: 'game_jdb_01',
    // name: '金雞報囍',
  },
  {
    image: 'game_jdb_02',
    // name: '好運777',
  },
  {
    image: 'game_jdb_03',
    // name: '唐伯虎點秋香',
  },
  {
    image: 'game_jdb_04',
    // name: '水晶王國',
  },
  {
    image: 'game_jdb_05',
    // name: '啤酒大亨',
  },
  {
    image: 'game_jdb_06',
    // name: '神偷妙賊',
  },
  {
    image: 'game_jdb_07',
    // name: '台灣黑熊',
  },
  {
    image: 'game_jdb_08',
    // name: '麻雀無雙',
  },
  {
    image: 'game_jdb_09',
    // name: '奧林匹亞神廟',
  },
  {
    image: 'game_jdb_10',
    // name: '幸運福娃',
  },
];

const GameCard = withNamespaces()((props) => {
  const { image, name } = props;
  const { t } = props;

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      <Card>
        <CardImg src={image} />
      </Card>

      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <div style={{ color: 'white', fontWeight: 'bold' }}>{name}</div>
        <div style={{ flex: 1 }} />
        <Button>{t('GameCard.Start')}</Button>
      </div>
    </div>
  );
});

export default withNamespaces()(GameList);
function GameList (props) {
  const { t } = props;
  return (
    <div
      style={{
        backgroundColor: '#101E25',
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <Container>
        <Row>
          {items.map((element, index) => {
            let image = `./images/${element.image}.jpg`;
            let name = t(`GameList.${element.image}`);
            return (
              <Col key={index} xs={'6'} sm={'4'} lg={'3'}>
                <GameCard image={image} name={name} />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};
